export const updateObject = (
    objectToUpdate, 
    setStateAction, 
    key, 
    value
  ) => {
    const newFieldValues = { ...objectToUpdate }
    if (value) {
      newFieldValues[key] = value
    }
    else {
      delete newFieldValues[key]
    }
    setStateAction(newFieldValues)
  }